import axios from 'axios';
import store from '../slices/store';
import { apiError } from '../slices/Auth/Login/reducer';

const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API_URL;

const getAuthTokens = () => {
    const authUserString = localStorage.getItem('authUser');
    let accessToken: string | null | undefined;
    let refreshToken: string | null | undefined;

    if (authUserString) {
        try {
            const authUser = JSON.parse(authUserString);
            accessToken = authUser?.access_token || null;
            refreshToken = authUser?.refresh_token || null;
        } catch (e) {
            console.error("Error parsing authUser:", e);
        }
    }

    return { accessToken, refreshToken };
};

// Create Axios instance
const axiosInstance = axios.create({
    baseURL: LARAVEL_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// **Add request interceptor to include access token**
axiosInstance.interceptors.request.use((config) => {
    const { accessToken } = getAuthTokens(); // Get fresh tokens before every request
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
});

// Add response interceptor for error handling**
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        const { refreshToken } = getAuthTokens();

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshResponse = await axios.post(`${LARAVEL_API_URL}/refresh-token`, {}, {
                    headers: {
                        Authorization: `Bearer ${refreshToken}`,
                    },
                })

                if (refreshResponse.status === 200) {
                    const data = JSON.parse(JSON.stringify(refreshResponse));
                    const newAccessToken = data.access_token;
                    const newRefreshToken = data.refresh_token;
                    const newRefreshTokenExpiresAt = data.refresh_token_expires_at;
                    // Ensure that 'authUser' is an object, even if 'localStorage.getItem' returns null
                    let authUser = JSON.parse(localStorage.getItem('authUser') || '{}');

                    // Update only the access_token and refresh_token
                    authUser.access_token = newAccessToken;
                    authUser.refresh_token = newRefreshToken;
                    authUser.refresh_token_expires_at = newRefreshTokenExpiresAt;

                    // Save the updated 'authUser' back to localStorage
                    localStorage.setItem('authUser', JSON.stringify(authUser))

                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return axiosInstance(originalRequest);
                }else{
                    console.error('Refesh token expired');
                    localStorage.removeItem('authUser');
                    window.location.href = '/login';
                }
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);
                store.dispatch(apiError("Session expired. Please login again"));
                localStorage.removeItem('authUser');
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
